import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';
import { APP_TIMESTAMP } from '../util/constants';

i18n
  .use(XHR)
  .use(LngDetector)
  .init({
    detection: {
      order: ['querystring', 'cookie'],
      lookupQuerystring: 'lang',
      caches: ['cookie'], // Cache user language to co
      cookieMinutes: 40320 // One month
    },
    // List the namespaces aka *.json files
    ns: [
      'common',
      'forgotpassword',
      'forms',
      'identification',
      'menu',
      'modals',
      'roots',
      'tables'
    ],
    debug: false,
    defaultNS: 'common',
    fallbackLng: 'fi',
    backend: {
      loadPath: (process.env.NODE_ENV === 'dev') ? '/i18n/{{lng}}/{{ns}}.json' : `/i18n/v/${APP_TIMESTAMP}/{{lng}}/{{ns}}.json`
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js